// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

let Types = {};

let fragmentConverter = {"__root":{"":{"f":""}}};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

function localDraftGeocodingStatus_decode($$enum) {
  if ($$enum === "NotCalled" || $$enum === "ErrorOutsideChapterBoundaries" || $$enum === "Called" || $$enum === "ErrorDuplicateListing" || $$enum === "Valid" || $$enum === "Error") {
    return $$enum;
  }
}

let localDraftGeocodingStatus_fromString = localDraftGeocodingStatus_decode;

function localDraftMlsStatus_decode($$enum) {
  if ($$enum === "NotCalled" || $$enum === "OnMlsButAllowed" || $$enum === "Called" || $$enum === "OnMls" || $$enum === "Error" || $$enum === "NotOnMls") {
    return $$enum;
  }
}

let localDraftMlsStatus_fromString = localDraftMlsStatus_decode;

let Utils = {
  localDraftGeocodingStatus_decode: localDraftGeocodingStatus_decode,
  localDraftGeocodingStatus_fromString: localDraftGeocodingStatus_fromString,
  localDraftMlsStatus_decode: localDraftMlsStatus_decode,
  localDraftMlsStatus_fromString: localDraftMlsStatus_fromString
};

let node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PropertyWizardRelayKeyFactsStreetAddress_formState",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PropertyWizardFormRelayValidatorsKeyFactsAddressStreetAddress_formState"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PropertyWizardFormRelayValidatorsKeyFactsAddressCityOrZip_formState"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "geocodingStatus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mlsStatus",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "LocalDraftFormState",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
